module.exports = __webpack_public_path__ + "static/media/9DESA4.28b0a237.jpg";